import { Route, useRouteMatch } from 'react-router-dom';

// Pages.
import ProjectPlanPage from 'pages/galleria/master-plane/zone-3/Type-F/plan/ProjectPlanPage';
import ProjectGalleryPage from 'pages/galleria/master-plane/zone-3/Type-F/gallery/ProjectGalleryPage';
import PaymentPage from 'pages/galleria/master-plane/zone-3/Type-F/payment/PaymentPage';
const Index = () => {
  const { path } = useRouteMatch();
  return (
    <>
      <Route exact path={`/galleria/master-plan/zone-3/type-f/plan`}>
        <ProjectPlanPage />
      </Route>
      <Route exact path={`/galleria/master-plan/zone-3/type-f/gallery`}>
        <ProjectGalleryPage />
      </Route>
      <Route exact path={`/galleria/master-plan/zone-3/type-f/payment`}>
        <PaymentPage />
      </Route>
    </>
  );
};

export default Index;
